<template lang="pug">
.view-platforms.content
  ui-navbar-panel(title="Статистика клиентов")
    | Период
    b-tag.is-dark.ml-2 30 дней
  div.columns
    div.column.is-three-fifths-desktop.is-full-tablet
      b-table(
        :data="platformStat",
        :loading="platforms.$state.loading",
        detail-key="id",
        default-sort="name",
        striped
      )
        //- Row
        //- template(slot-scope="{ row }")
        b-table-column(field="id", label="ID", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.platform.id }}

        //- b-table-column(field="priority", label="Приоритет", width="1", nowrap, sortable, numeric v-slot="{row}")

        b-table-column(field="name", label="Тип", width="1", sortable v-slot="{row}")
          ui-label.mr-5(v-if="row.platform.label", :label="row.platform.label", is-rounded)
        b-table-column(field="name", label="Название", sortable v-slot="{row}")
          //- platform-priority-icon(:value="row.platform.priority")
          | {{ row.platform.name }}

        b-table-column(field="tasks", label="Задач" numeric, sortable v-slot="{row}")
          | {{ row.tasks }}
        b-table-column(field="activity_success", label="Закрыто" numeric, sortable v-slot="{row}")
          | {{ row.activity_success }}
        b-table-column(field="activity", label="Активностей" numeric, sortable v-slot="{row}")
          | {{ row.activity_success }}

        b-table-column(field="platform.active_tasks_count" label="Всего активно" numeric sortable v-slot="{row}")
          b-tooltip.tag.is-danger.mb-0(v-if="row.platform.active_tasks_count", label="Активных задач", size="default") {{ row.platform.active_tasks_count }}

        b-table-column(field="platform.unactive_tasks_count", label="Всего закрыто", numeric, sortable v-slot="{row}")
          b-tooltip.tag.is-primary.mb-0(v-if="row.platform.unactive_tasks_count", label="Закрытых задач", size="default") {{ row.platform.unactive_tasks_count }}
</template>

<script>
import Platform from '@/models/Platform';
import api from '@/api';

export default {
  name: 'view-stat',

  data: () => ({
    platforms: Platform.collection(),
    stat: {},
  }),

  computed: {
    platformStat() {
      return this.platforms.items.map(platform => {
        return {
          platform,
          ...(this.stat[platform.id] || {}),
        };
      });
    },
  },

  methods: {
    loadHelpdeskStat() {
      api
        .for('helpdesk')
        .read('stat')
        .then(({ data }) => {
          this.stat = data;
        });
    },

    loadPlatforms() {
      this.platforms.$fetch({
        include: 'label',
        filter: { status: 'ne:0' },
        scope: 'activeTasksCount,unactiveTasksCount',
      });
    },

    updatePlatformInfo(platform) {
      platform.$pullPlatformStat();
    },

    updateAllPlatformInfo() {
      this.platforms.items.forEach(platform => {
        platform.$pullPlatformStat();
      });
    },
  },

  created() {
    this.loadPlatforms();
    this.loadHelpdeskStat();
  },
};
</script>
